.main-info {
  position: relative;
  margin: 10px 0;
}

@media screen and (max-width: 979px) {
  .main-info {
    margin: 8px;
    position: unset;
  }
}

@media screen and (min-width: 980px) {
  .main-info.list {
    position: unset;
    margin-top: 0;
    display: flex;
    flex-wrap: wrap;
  }
}

.main-info.list .pes-tags {
  flex-direction: row;
}

@media screen and (max-width: 719px) {
  .main-info.list .pes-tags {
    flex-direction: column;
  }
}

@media screen and (min-width: 980px) {
  .main-info.grid .pes-tags .tag {
    max-width: 250px;
  }
}

.main-info .pes-tags {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
}

.main-info__product-links {
  margin-bottom: 3px;
  height: -moz-fit-content;
  height: fit-content;
  width: 100%;
  display: flex;
  align-items: center;
  word-break: normal;
}

@media screen and (min-width: 980px) {
  .list .main-info__product-links {
    margin-bottom: 10px;
  }
}

.logo {
  position: absolute;
  bottom: calc(100% + 16px);
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
}

@media screen and (max-width: 979px) {
  .logo {
    bottom: 8px;
  }

  :host(:not([dir="rtl"])) .logo {
    left: 0;
    margin-left: 8px;
  }

  :host([dir="rtl"]) .logo {
    right: 0;
    margin-right: 8px;
  }

  .logo .green-premium,
.logo .brand {
    display: none;
  }
}

@media screen and (min-width: 980px) {
  .list .logo {
    bottom: 28px;
  }

  :host(:not([dir="rtl"])) .list .logo {
    left: 0;
    margin-left: 20px;
  }

  :host([dir="rtl"]) .list .logo {
    right: 0;
    margin-right: 20px;
  }
}

.logo .made-in-america {
  overflow: hidden;
}

@media screen and (min-width: 980px) {
  .list .logo .made-in-america {
    margin-top: 0;
  }
}

.logo .brand {
  width: 60px;
  overflow: hidden;
}

@media screen and (min-width: 980px) {
  .list .logo .brand {
    vertical-align: middle;
  }
}

.logo .green-premium {
  width: 54px;
  height: 20px;
  overflow: hidden;
}

.commercial {
  display: inline-block;
  width: auto;
  margin: 0;
  padding: 0 12px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  background-color: #b10043;
  border-radius: 4px;
}

a {
  color: inherit;
  display: inline-flex;
}

a, a:hover {
  text-decoration: none;
}

.enumber {
  display: inline-block;
  color: #626469;
  font-weight: normal;
  font-size: 12px;
  line-height: 15px;
}

:host(:not([dir="rtl"])) .enumber {
  margin-right: 10px;
  padding-right: 10px;
  border-right: 1px solid #f3f2f2;
}

:host([dir="rtl"]) .enumber {
  margin-left: 10px;
  padding-left: 10px;
  border-left: 1px solid #f3f2f2;
}

@media screen and (max-width: 979px) {
  .enumber {
    font-size: 10px;
  }

  :host(:not([dir="rtl"])) .enumber {
    margin-right: 0px;
    padding-right: 5px;
  }

  :host([dir="rtl"]) .enumber {
    margin-left: 0px;
    padding-left: 5px;
  }
}

.enumber .enumber-link {
  visibility: visible;
}

:host(:not([dir="rtl"])) .enumber .enumber-link span {
  margin-right: 5px;
}

:host([dir="rtl"]) .enumber .enumber-link span {
  margin-left: 5px;
}

@media screen and (max-width: 979px) {
  :host(:not([dir="rtl"])) .enumber .enumber-link span {
    margin-right: 5px;
  }

  :host([dir="rtl"]) .enumber .enumber-link span {
    margin-left: 5px;
  }
}

@media screen and (min-width: 980px) {
  .list .enumber {
    order: 1;
    height: 20px;
    font-size: 14px;
    line-height: 20px;
  }

  :host(:not([dir="rtl"])) .list .enumber {
    padding-right: 10px;
    margin-right: 10px;
    border-right: 1px solid #f3f2f2;
  }

  :host([dir="rtl"]) .list .enumber {
    padding-left: 10px;
    margin-left: 10px;
    border-left: 1px solid #f3f2f2;
  }

  .grid .enumber {
    font-size: 12px;
    line-height: 15px;
  }
}

.commercial-reference,
.commercial-reference__bundle {
  color: #626469;
  font-size: 0.75rem;
}

@media screen and (max-width: 979px) {
  .commercial-reference,
.commercial-reference__bundle {
    font-size: 0.875rem;
    font-weight: 400;
  }
}

.commercial-reference-link,
.commercial-reference__bundle-link {
  visibility: visible;
  display: -webkit-box;
  /* stylelint-disable-line */
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

@media screen and (min-width: 980px) {
  .commercial-reference,
.commercial-reference__bundle {
    display: inline-block;
  }

  .list .commercial-reference,
.list .commercial-reference__bundle {
    order: 2;
    height: 20px;
    font-size: 14px;
    line-height: 20px;
  }

  .grid .commercial-reference,
.grid .commercial-reference__bundle {
    font-size: 12px;
    line-height: 18px;
  }
}

.description {
  overflow: hidden;
  display: block;
  display: -webkit-box;
  /* stylelint-disable-line */
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  font-weight: bold;
  color: #333333;
  font-size: 0.875rem;
  line-height: 25px;
  max-height: 100px;
}

.description:hover, .description:focus {
  text-decoration: underline;
}

.description-mobile {
  font-size: 0.875rem;
  line-height: 20px;
}

.description-link {
  display: -webkit-box;
  /* stylelint-disable-line */
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

@media screen and (min-width: 980px) {
  .description {
    -webkit-line-clamp: 3;
    max-height: 60px;
  }

  .list .description {
    order: 4;
    width: 100%;
  }

  .grid .description {
    font-size: 14px;
    line-height: 20px;
  }
}

.description-link__content {
  margin: 0;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
}

@media screen and (max-width: 979px) {
  .description-link__content {
    line-height: 20px;
  }
}

@media screen and (min-width: 980px) {
  .description-link__content.grid {
    min-height: 60px;
  }
}

.bundle-description {
  overflow: hidden;
  display: block;
  display: -webkit-box;
  /* stylelint-disable-line */
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  font-weight: bold;
  color: #626469;
  font-size: 0.875rem;
  line-height: 1.25rem;
  max-height: 100px;
  margin-bottom: 16px;
}

.bundle-description a:hover,
.bundle-description a:focus {
  color: #3dcd58;
}

@media screen and (max-width: 719px) {
  .bundle-description {
    -webkit-line-clamp: 10;
    max-height: 200px;
  }
}

.main-product-link,
.bundle-product-link {
  display: inline;
  color: #333333;
}

.count-ellips {
  cursor: default;
  font-size: 0.625rem;
  line-height: 1rem;
  position: relative;
  display: inline-block;
  width: 22px;
  height: 16px;
  flex-shrink: 0;
  border-radius: 10px;
  vertical-align: middle;
  text-align: center;
  background-color: #e7e6e6;
  color: #0f0f0f;
}

:host(:not([dir="rtl"])) .count-ellips {
  margin-right: 5px;
}

:host([dir="rtl"]) .count-ellips {
  margin-left: 5px;
}

.tooltip-content {
  max-width: 263px;
  max-height: 160px;
}

.tooltip-content .tooltip-title {
  font-size: 0.75rem;
  font-weight: 700;
  color: #9fa0a4;
  margin-bottom: 9px;
}

:host(:not([dir="rtl"])) .tooltip-content .count-ellips {
  margin-right: 8px;
}

:host([dir="rtl"]) .tooltip-content .count-ellips {
  margin-left: 8px;
}

.tooltip-content .main-product-link,
.tooltip-content .bundle-product-link {
  color: #42b4e6;
  line-height: 1rem;
  margin-bottom: 6px;
}

.tooltip-content .tooltip-main-product,
.tooltip-content .tooltip-bundle-product {
  display: flex;
}

.tooltip-content .commercial-reference__bundle {
  display: block;
}

:host(:not([dir="rtl"])) .tooltip-content .commercial-reference__bundle {
  margin-left: 30px;
}

:host([dir="rtl"]) .tooltip-content .commercial-reference__bundle {
  margin-right: 30px;
}

.tooltip-content .tooltip-bundle-rating {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  margin-bottom: 6px;
}

.badge-wrapper {
  display: flex;
  margin: 10px 0 5px;
  flex-wrap: wrap;
  gap: 4px;
}

@media screen and (min-width: 980px) {
  .list .badge-wrapper {
    margin: 12px 0 8px 0;
    min-height: 20px;
    width: 100%;
    order: 3;
  }
}

@media screen and (max-width: 979px) {
  .main-info__qds-tag {
    --qds-control-small-height: 1.75rem;
  }
}